import { object, string, number, array } from 'yup'
import queryString from 'qs'

export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  providerId: string().required(),
  memberId: string().required(),
  page: object({
    skip: number().default(0),
    limit: number().default(20).max(100),
  }).default({}),
  dateRange: object({
    start: string().notRequired(),
    end: string().notRequired(),
  }).notRequired(),
  filter: object({
    visitType: array().of(string()).notRequired(),
    dateRange: object({
      start: string().notRequired(),
      end: string().notRequired(),
    }).notRequired(),
  }).notRequired(),
})

export const url = ({ providerId, memberId, page = {}, filter = {} }) => {
  const { skip = 0, limit = 20 } = page
  const queryParams = {
    skip,
    limit,
    filter: {
      date_range: filter.dateRange,
      visit_type: filter.visitType,
    },
  }

  return `/v1/providers/${providerId}/member/${memberId}/diagnosis-history?${queryString.stringify(queryParams, {
    arrayFormat: 'repeat',
  })}`
}

// Response type for TypeScript consumers
export const MockSuccessfulResponse = {
  data: {
    paginated: [
      {
        id: 'dx_123',
        icd_10_code: 'F41.1',
        description: 'Generalized anxiety disorder',
        visit_date: '2024-06-15T10:30:00Z',
        visit_id: 'visit_456',
        visit_type: 'psychiatry',
        provider_id: 'prov_789',
        provider_name: 'Dr. Jane Smith',
        confirmed: false,
      },
    ],
    meta: {
      results: 45,
      has_more: true,
      skip: 0,
      limit: 20,
    },
  },
}

export const shouldNotLogoutOn403Error = true
